import Styles from './Sections.module.scss'
import { SectionProps } from './Types'
import { CHANNELS_BY_ONBOARDING_SELECTIONS } from '../constants'
import { Common } from './Common'
import { NewDesignButtonV2, NewDocumentButtonV2 } from '../WizardButton/WizardButton'
import { BestPerformingPostsCarouselSection } from 'screens/blaze/Home/components/Catalogue/BestPerformingPostsCarouselSection/BestPerformingPostsCarouselSection'
import { useAllBestPerformingPlatformPosts } from 'hooks/queries/useAllBestPerformingPlatformPosts'
import { AdvancedTools } from './AdvancedTools'
import { PopularTemplateCarousel } from '../TemplateCarousel/TemplateCarousel'
import { useRegistrationData } from 'hooks/queries/users/useRegistrationData'
import { useMemo } from 'react'
import { CreationCategoryTypes } from 'components/FirstTimeExperienceModal/Types'
import { BrainstormIdeasBanner } from '../BrainstormIdeasBanner/BrainstormIdeasBanner'
import { SavedDrafts } from '../SavedDrafts/SavedDrafts'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useWizardDrafts } from 'hooks/queries/wizardDrafts/useWizardDrafts'

export const RecentlyUsed = ({ recentWizards, searchRef, ...props }: SectionProps) => {
  const { data } = useAllBestPerformingPlatformPosts()
  const showBestPerformingPosts = data?.best_performing_platform_posts && data.best_performing_platform_posts.length > 0
  const wizardDraftsQuery = useWizardDrafts()
  const wizardDrafts = wizardDraftsQuery.data

  return (
    <div>
      {recentWizards && <Common channels={recentWizards} heading="Your recently used content wizards" {...props} />}
      {wizardDrafts && wizardDrafts.length > 0 && (
        <div className={Styles.commonPadding}>
          <Heading level={3}>Saved Drafts</Heading>
          <div className={Styles.marginTop15}>
            <SavedDrafts wizardDrafts={wizardDrafts} {...props} />
          </div>
        </div>
      )}
      {showBestPerformingPosts && (
        <div className={Styles.bestPerformingPostsContainer}>
          <BestPerformingPostsCarouselSection isForYou />
        </div>
      )}
      <Common channels={[]} heading="Start with a clean slate" {...props}>
        <NewDesignButtonV2 size="lg" />
        <NewDocumentButtonV2 size="lg" />
      </Common>
    </div>
  )
}

export const GettingStarted = ({ recentWizards, ...props }: SectionProps) => {
  const { data } = useRegistrationData({ cacheTime: Infinity })
  const contentCreationCategory = data?.user_registration_data?.content_creation_category as CreationCategoryTypes
  const contentCreationSubcategory = data?.user_registration_data?.content_creation_subcategory

  const { title, channels } = useMemo(() => {
    const categoryData = CHANNELS_BY_ONBOARDING_SELECTIONS[contentCreationCategory]

    if (!categoryData) {
      return { title: '', channels: [] }
    }

    if ('channels' in categoryData) {
      return categoryData
    }

    if (contentCreationSubcategory && contentCreationSubcategory in categoryData) {
      return categoryData[contentCreationSubcategory as keyof typeof categoryData]
    }

    return { title: '', channels: [] }
  }, [contentCreationCategory, contentCreationSubcategory])

  return (
    <div>
      <Common channels={channels} heading={title} {...props} />
      <BrainstormIdeasBanner {...props} />
      <PopularTemplateCarousel heading="The best performing templates on Blaze" />
      <Common channels={[]} heading="Start with a clean slate" {...props}>
        <NewDesignButtonV2 size="lg" />
        <NewDocumentButtonV2 size="lg" />
      </Common>
    </div>
  )
}

export const ForYou = ({ recentWizards, ...props }: SectionProps) => {
  switch (props.forYouPageType) {
    case 'recently_used':
      return <RecentlyUsed recentWizards={recentWizards} {...props} />
    case 'power_up':
      return <AdvancedTools {...props} />
    default:
      return <GettingStarted recentWizards={recentWizards} {...props} />
  }
}
